// extracted by mini-css-extract-plugin
module.exports = {"chat":"style_chat__2rr5Z","item-inner":"style_item-inner__3Pzc7"};